export class Company{
    id:number;
    name:string;
    routes:any;
    status:number;
    logo:string;
    ws:string;
}